<template>
  <div class="pt-12">
    <!-- start features -->

    <!-- start cta -->
    <section class="relative px-4 py-12 -mt-32 text-center sm:px-8 lg:px-16 xl:px-40 2xl:px-64 md:text-left">
      <div class="flex flex-col items-center justify-between px-12 py-10 bg-gray-300 rounded-lg shadow-lg md:flex-row">
        <div class="w-full md:w-2/3">
          <h3 class="text-3xl font-bold leading-tight text-gray-700">Potrzebujesz pomocy, masz pytania?</h3>
          <a href="tel:+48881123123" class="mt-2 text-4xl font-bold text-blue-500 cursor-pointer md:max-w-md"
            >+48 609 020 455</a
          >
        </div>

        <div class="w-full mt-6 md:w-1/3 md:text-right md:mt-0">
          <router-link
            class="inline-block px-6 py-4 text-2xl font-bold text-white bg-blue-600 rounded-lg transition duration-500 ease-in-out transform motion-reduce:transform-none hover:-translate-y-1 hover:bg-blue-400"
            :to="'/kontakt'"
            >Napisz do nas !</router-link
          >
        </div>
      </div>
    </section>
    <!-- end cta -->

    <footer class="px-4 pt-12 pb-10 text-center bg-white sm:px-8 lg:px-16 xl:px-40 2xl:px-64 sm:text-left">
      <div class="flex flex-col sm:flex-row sm:flex-wrap">
        <div class="mt-8 sm:w-1/2 sm:mt-0 lg:w-1/5 lg:mt-0">
          <h6 class="text-sm font-bold text-gray-600 uppercase">Menu</h6>
          <ul class="mt-4">
            <li>
              <router-link to="/oferta">Oferta</router-link>
            </li>
            <li class="mt-2">
              <router-link to="/praca">Praca</router-link>
            </li>
            <li class="mt-2">
              <router-link to="/kontakt">Kontakt</router-link>
            </li>
          </ul>
        </div>

        <div class="mt-8 sm:w-1/2 sm:mt-12 lg:w-1/5 lg:mt-0">
          <h6 class="text-sm font-bold text-gray-600 uppercase">Kontakt</h6>
          <ul class="mt-4">
            <li>
              <a href="#">hafciarnia@haft-poznan.pl</a>
            </li>
            <li class="mt-2">
              <a href="tel:48616527101">+48 616 527 101</a>
              <br />
              <a href="tel:48663985010">+48 663 985 010</a>
            </li>
          </ul>
        </div>

        <div class="mt-12 sm:w-1/2 lg:w-2/5 lg:mt-0 lg:pl-12">
          <div>
            <router-link to="/">
              <img src="../../../client/assets/logo-haft.png" alt="logo" />
            </router-link>
          </div>

          <p class="mt-4 text-base text-gray-600">
            Nasza firma istnieje na rynku od stycznia 2005 roku. Działamy głównie na terenie Poznania, Wielkopolski, ale
            nie tylko. Realizujemy dziesiątki zleceń na terenie całego kraju oraz Europy.
          </p>
        </div>
      </div>

      <div class="mt-16">
        <hr class="mb-8" />
        <p class="text-sm text-gray-600">Haft Poznań | P. Woźny © 2020/2021. All rights reserved.</p>
      </div>
    </footer>
  </div>
  <!-- end footer -->
</template>

<script>
export default {
  name: "Footer",
  components: {},
};
</script>

<style lang="scss" scoped></style>
